import * as EmailValidator from "email-validator"

export function ValidateEmailAddress(emailAddress: string) {
  return EmailValidator.validate(emailAddress)
}
